import { FC } from 'react';
import { getDiscount } from '@app/shared/helpers';
import { LabelDiscountTypeProps } from './TypeProps';
import classNames from 'classnames';

import styles from './LabelDiscount.module.scss';

export const LabelDiscount: FC<LabelDiscountTypeProps> = ({ newPrice, oldPrice, className }) => {
  if ((!newPrice && !oldPrice) || oldPrice === newPrice) {
    return null;
  }
  return <div className={classNames(styles.Container, className)}>Скидка -{getDiscount(newPrice, oldPrice)}%</div>;
};
